import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "javascript-reference"
    }}>{`JavaScript Reference`}</h1>
    <p>{`UXP provides a set of common APIs that are available in UXP-powered host applications, including Adobe Photoshop 2021. These are included in the global context and also as `}<inlineCode parentName="p">{`require`}</inlineCode>{`-able modules.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Global%20Members/index.md"
        }}>{`Global Members`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Modules/index.md"
        }}>{`Modules`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      